<template>
  <div v-show="show" class="shop-list">
    <div v-if="storeInfo.storeDisable === 'OPEN'" class="list-wrapper">
      <div class="content-wrapper">
        <div class="h-full">
          <div class="c_group">
            <div style="position: absolute; right: 20px; top: 20px;">
              <a-tooltip placement="left">
                <template slot="title">
                  <span>平台销售是指卖家面对平台用户宣传的商品，销售内容需要符合法律法规要求及电商平台的监管规范，商品需要审核后才能上架</span>
                </template>
                <span style="font-size: 14px; color: #237FFA;margin-right: 5px;">平台销售</span>
                <a-icon type="exclamation-circle" style="font-size: 14px; color: #237FFA;" />
              </a-tooltip>
            </div>
            <XzTagGroup
              style="border-bottom: none"
              :data="marketEnableList"
              :active="outform.marketEnable"
              @handleClick="v => handleOutChange('marketEnable', v)"
            >
              <span class="title">上架状态</span>
            </XzTagGroup>
            <XzTagGroup
              style="padding-top: 0"
              :data="authFlagList"
              :active="outform.authFlag"
              @handleClick="v => handleOutChange('authFlag', v)"
            >
              <span class="title">审核状态</span>
            </XzTagGroup>
          </div>
          <div id="_shopGoods" class="table-wrapper" :class="{ fullscreen: isFullScreen }">
            <xz-table
              ref="xzTable"
              :columns="columnLists"
              :data="data"
              :searchAttrs="searchAttrs"
              :searchVal.sync="outform.nameOrSnOrModelOrSimpleSpecsOrBrandName"
              :toolsAttrs="toolsAttrs"
              :scroll="{ x: '100%', y: scrollHeight }"
              :drawerVisible.sync="drawerVisible"
              :drawerWidth="500"
              rowKey="id"
              :enableRowSelection="true"
              :selectedRowKeys="selectedKeys"
              :getCheckboxProps="(record) => ({
                props: {
                  disabled: !(record.terminalSource !== 'MINI_PROGRAM' && record.releaseStatus === 'RELEASED' && record.authFlag === 'PASS' && ['UPPER', 'DOWN'].includes(record.marketEnable))
                },
              })"
              @change="handleSelectionChange"
              @search="handleAdvancedQuery"
              @refresh="handleReset"
              @fullScreen="handleFullScreen"
            >
              <template #drawer>
                <div style="flex: 1; overflow: auto" class="advanced-search">
                  <el-form :model="form" label-width="120px">
                    <el-form-item label="原厂备件号">
                      <el-input v-model.trim="form.storeSn" placeholder="请输入" clearable />
                    </el-form-item>
                    <el-form-item label="是否医疗件">
                      <el-select v-model="form.medicalFlag" placeholder="请选择" clearable filterable>
                        <el-option label="全部" :value="null"></el-option>
                        <el-option label="是" :value="true"></el-option>
                        <el-option label="否" :value="false"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="商品类型">
                      <ChooseGoodsCategory ref="chooseGoodsCategoryRef" checkStrictly @handleSelect="handleSelectCategory" />
                    </el-form-item>
                    <el-form-item label="产品注册证号">
                      <el-input v-model.trim="form.registerCode" placeholder="请输入" clearable />
                    </el-form-item>
                    <el-form-item label="更新时间">
                      <el-date-picker
                        v-model="timeArr"
                        type="daterange"
                        range-separator="-"
                        value-format="yyyy-MM-dd"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        style="width: 100%;">
                      </el-date-picker>
                    </el-form-item>
                    <el-form-item label="适配设备">
                      <el-input v-model.trim="form.deviceNameOrModelOrBrandName" placeholder="请输入" clearable />
                    </el-form-item>
                    <el-form-item label="适配品牌">
                      <el-input v-model.trim="form.adaptedBrandName" placeholder="请输入" clearable />
                    </el-form-item>
                    <el-form-item label="适配设备分类">
                      <ChooseGoodsPlatFormCategory useXieApi ref="chooseGoodsPlatFormCategoryRef" checkStrictly @handleValidate="handleValidate" @handleSelect="handleSelectPlatFormCategory" />
                    </el-form-item>
                  </el-form>
                </div>
                <div style="text-align: right; height: 68px; line-height: 68px">
                  <a-button @click="handleEmpty">重置</a-button>
                  <a-button type="primary" style="margin-left: 10px" @click="handleAdvancedQuery">确定</a-button>
                </div>
              </template>
              <template #buttons>
                <el-button v-if="$withPermission('gongxutong:sale_goods:subscription:release')" @click="handleCreate" type="primary" size="mini">发布商品</el-button>
                <el-button v-if="$withPermission('gongxutong:sale_goods:subscription:up')" @click="handleBatchAction('UPPER')" :disabled="!selectedLists.length" type="primary" size="mini" plain>批量上架</el-button>
                <el-button v-if="$withPermission('gongxutong:sale_goods:subscription:down')" @click="handleBatchAction('DOWN')" :disabled="!selectedLists.length" type="primary" size="mini" plain>批量下架</el-button>
              </template>
              <template #custom>
                <tableHeaderConfiguration businessType="platformGoodsList" :disabledList="disabledList" :baseLists="baseLists" @updateColumnList="updateColumnList" />
              </template>
              <template slot="imageList" slot-scope="imageList">
                <span v-if="imageList && imageList.length > 0">
                  <el-image
                    :src="imageList[0].url"
                    :preview-src-list="imageList.map(img => img.url)"
                    style="width: 32px; height: 32px; margin-right: 5px;"
                  />
                  <span v-if="imageList.length > 1">...</span>
                </span>
                <span v-else>暂无图片</span>
              </template>
              <template slot="sn" slot-scope="sn, record">
                <div @click="handleGoodsDetail(record.id)" class="code">{{ sn ||'--' }}</div>
              </template>
              <template slot="authFlag" slot-scope="_, record">
                <span :class="['c_tag', record.releaseStatus === 'RELEASED' ? getColor(record.authFlag) : '']">
                  {{ record.authFlag === 'TOBEAUDITED' ? '待审核' : record.releaseStatus === 'RELEASED' ? record.authFlagDesc : '--' }}
                </span>
                <el-tooltip
                  v-if="record.authFlag === 'REFUSE'"
                  effect="dark"
                  :content="`驳回原因：${record.authMessage}`"
                  placement="bottom"
                >
                  <i class="el-icon-warning-outline"></i>
                </el-tooltip>
              </template>
              <template slot="marketEnable" slot-scope="_, record">
                <span v-if="record.releaseStatus === 'RELEASED' && record.authFlag === 'PASS'" :class="['c_tag', record.authFlag === 'PASS' ? getColor(record.marketEnable) : '']">
                  {{ record.marketEnable === 'UPPER' ? '已上架' : record.marketEnable === 'DOWN' ? '已下架' : '--' }}
                </span>
                <span v-else-if="record.releaseStatus === 'NOT'" :class="['c_tag', record.releaseStatus === 'NOT' ? getColor(record.releaseStatus) : '']">
                  未发布
                </span>
                <span v-else>--</span>
              </template>
              <template slot="storeSnTitle">
                原厂备件号
                <a-tooltip placement="top">
                  <template slot="title">
                    <span>备件码</span>
                  </template>
                  <a-icon type="exclamation-circle" style="font-size: 14px; color: #8c8c8c;" />
                </a-tooltip>
              </template>
              <template slot="storeSn" slot-scope="storeSn">
                {{ storeSn }}
              </template>
              <template slot="action" slot-scope="_, record">
                <template v-if="record.terminalSource !== 'MINI_PROGRAM'">
                  <template v-if="$withPermission('gongxutong:sale_goods:subscription:edit') && record.authFlag === 'REFUSE'">
                    <a @click="() => handleAction(record, 'modify')" style="margin-left: 8px">编辑</a>
                  </template>
                  <template v-if="record.releaseStatus === 'RELEASED' && record.authFlag === 'PASS'">
                    <a v-if="$withPermission('gongxutong:sale_goods:subscription:up') && record.marketEnable === 'UPPER'"
                      @click="() => handleAction(record, 'marketEnable')" style="margin-left: 8px">
                      下架
                    </a>
                    <a v-if="$withPermission('gongxutong:sale_goods:subscription:down') && record.marketEnable === 'DOWN'"
                      @click="() => handleAction(record, 'marketEnable')" style="margin-left: 8px">
                      上架
                    </a>
                  </template>
                  <template v-if="$withPermission('gongxutong:sale_goods:subscription:release')">
                    <a v-if="record.releaseStatus === 'RELEASED' && record.authFlag === 'PASS' && ['UPPER', 'DOWN'].includes(record.marketEnable)" @click="() => handleAction(record, 'cancel')" style="margin-left: 8px">取消发布</a>
                    <a v-if="record.releaseStatus === 'NOT'" @click="() => handleAction(record, 'publish')" style="margin-left: 8px">发布</a>
                  </template>
                </template>
              </template>
            </xz-table>
          </div>
        </div>
      </div>
      <div class="pagination-wrapper">
        <a-pagination
          :current="page.pageNum"
          :total="total"
          :show-total="total => `共 ${total} 条`"
          show-size-changer
          :pageSizeOptions="['10', '20', '30', '50', '100']"
          show-quick-jumper
          :pageSize.sync="page.pageSize"
          @change="handleNumChange"
          @showSizeChange="handleSizeChange"
        />
      </div>
    </div>
    <div v-else class="content_block empty">
      <img :src="require('@/assets/empty_shop.png')" class="empty-img" />
      <template v-if="storeInfo.storeDisable === 'APPLYING'">
        <div class="desc">云仓开通审核中，请耐心等待，预计1-3个工作日</div>
      </template>
      <template v-else-if="storeInfo.storeDisable === 'REFUSED'">
        <div class="desc">
          <div>云仓开通审核失败，请修改后重新提交审核！</div>
          <div style="padding-top: 5px;">失败原因：{{ storeInfo.auditReason }}</div>
        </div>
        <el-button @click="handleOpenMarket()" size="small" type="primary">重新开通</el-button>
      </template>
      <template v-else>
        <template v-if="userInfo.adminFlag">
          <div class="desc">暂未开通云仓，开通云仓后可在小紫平台展示所需要销售的商品</div>
          <el-button @click="handleOpenMarket()" size="small" type="primary">开通店铺</el-button>
        </template>
        <div v-else class="desc">暂未开通云仓，请联系管理员进行开通，开通云仓后可以在小紫平台展示所需销售的商品</div>
      </template>
    </div>

    <OpenMarketDialog ref="openMarketRef" :id="storeInfo.id" @refresh="init" />
    <GoodsDetailDialog ref="goodsDetailDialogRef" from="platform" :storeId="storeInfo.id" :id="currentId" />
    <EditDialog ref="editDialogRef" from="platform" :storeId="storeInfo.id" :id="currentId" @refresh="handleSearch" />
  </div>
</template>
<script>
import * as Moment from 'dayjs';
import { getMarketStoreByLicenseNum, getMarketStoreByLinkPhone, getSkuPageList, updateMarketEnable, tenantDetail, cancelRelease, getSkuCount } from '@/api/shop';
import { companyDetail } from '@/api/company';
import OpenMarketDialog from './components/openMarketDialog.vue';
import EditDialog from './components/editDialog.vue';
import xzTable from '@/components/xiaozi-ui/xz-table/src/table.vue';
import XzTagGroup from '@/components/xiaozi-ui/xz-tag-group';
import tableHeaderConfiguration from '@/components/tableHeaderConfiguration.vue';
import ChooseGoodsCategory from '@/views/Goods/components/chooseGoodsCategory.vue';
import GoodsDetailDialog from './components/goodsDetailDialog.vue';
import ChooseGoodsPlatFormCategory from '@/views/Goods/components/chooseGoodsPlatFormCategory.vue';

const COMMON_COLUMNS = [
  {
    title: '商品图片',
    dataIndex: 'imageList',
    key: 'imageList',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'imageList' },
  },
  {
    title: '商品编码(sku)',
    dataIndex: 'sn',
    key: 'sn',
    width: 130,
    ellipsis: true,
    scopedSlots: { customRender: 'sn' },
  },
  {
    title: '商品名称',
    dataIndex: 'goodsName',
    key: 'goodsName',
    width: 160,
    ellipsis: true,
    customRender: text => {
      return text || '--';
    },
  },
  {
    title: '商品别名',
    dataIndex: 'anotherName',
    key: 'anotherName',
    width: 120,
    ellipsis: true,
    customRender: text => {
      return text || '--';
    },
  },
  {
    title: '型号',
    dataIndex: 'model',
    key: 'model',
    width: 100,
    ellipsis: true,
    customRender: text => {
      return text || '--';
    },
  },
  {
    title: '规格',
    dataIndex: 'simpleSpecs',
    key: 'simpleSpecs',
    width: 100,
    ellipsis: true,
    customRender: text => {
      return text || '--';
    },
  },
  {
    title: '品牌',
    dataIndex: 'brandName',
    key: 'brandName',
    width: 160,
    ellipsis: true,
    customRender: text => {
      return text || '--';
    },
  },
  {
    title: '销售单价(含税)',
    dataIndex: 'price',
    key: 'price',
    width: 130,
    ellipsis: true,
    customRender: text => {
      return text === '' || text === null || text === undefined ? '面议' : text.toLocaleString('en-US', { minimumFractionDigits: 2});
    },
  },
  {
    title: '数量',
    dataIndex: 'quantity',
    key: 'quantity',
    width: 80,
    ellipsis: true,
    customRender: (text, row) => {
      return text !== null && text !== undefined && text !== '' ? `${text}${row.goodsUnit}` : '--';
    },
  },
  {
    title: '审核状态',
    dataIndex: 'authFlag',
    key: 'authFlag',
    width: 130,
    ellipsis: true,
    scopedSlots: { customRender: 'authFlag' },
  },
  {
    title: '上架状态',
    dataIndex: 'marketEnable',
    key: 'marketEnable',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'marketEnable' },
  },
  {
    originTitle: '原厂备件号',
    dataIndex: 'storeSn',
    key: 'storeSn',
    width: 120,
    ellipsis: true,
    scopedSlots: { title: 'storeSnTitle', customRender: 'storeSn' },
  },
  {
    title: '是否医疗件',
    dataIndex: 'medicalFlag',
    key: 'medicalFlag',
    width: 110,
    ellipsis: true,
    customRender: text => {
      return text === true ? '是' : text === false ? '否' : '--';
    },
  },
  {
    title: '商品分类',
    dataIndex: 'categoryName',
    key: 'categoryName',
    width: 160,
    ellipsis: true,
    customRender: text => {
      return text || '--';
    },
  },
  {
    title: '产品注册证/备案凭证',
    dataIndex: 'registerCode',
    key: 'registerCode',
    width: 170,
    ellipsis: true,
    customRender: text => {
      return text || '--';
    },
  },
  {
    title: '更新时间',
    dataIndex: 'lastUpdateTime',
    key: 'lastUpdateTime',
    width: 170,
    ellipsis: true,
    customRender: text => {
      return text ? Moment(text).format('YYYY-MM-DD HH:mm:ss') : '--';
    },
  },
];

export default {
  name: 'SHOP_GOODS',
  components: {
    xzTable,
    XzTagGroup,
    tableHeaderConfiguration,
    OpenMarketDialog,
    EditDialog,
    ChooseGoodsCategory,
    GoodsDetailDialog,
    ChooseGoodsPlatFormCategory,
  },
  data () {
    return {
      currentId: null,
      current: {},
      show: false,
      userInfo: {},
      storeInfo: {},
      companyInfo: {},
      drawerVisible: false,
      scrollHeight: 600,
      isFullScreen: false,
      selectedKeys: [],
      selectedLists: [],
      searchAttrs: {
        show: true,
        placeholder: '商品名称/编码/型号/规格/品牌',
        data: 'nameOrSnOrModelOrSimpleSpecsOrBrandName',
      },
      disabledList: [],
      columnLists: [
        ...COMMON_COLUMNS,
      ],
      baseLists: [
        ...COMMON_COLUMNS,
      ],
      timeArr: [],
      form: {
        storeSn: '',
        medicalFlag: null,
        registerCode: '',
        merchantGoodsCategoryId: null,
        updateTimeStart: '',
        updateTimeEnd: '',
        deviceNameOrModelOrBrandName: '',
        adaptedBrandName: '',
        adaptedCategoryId: null,
      },
      outform: {
        releaseStatus: null,
        marketEnable: null,
        authFlag: null,
        nameOrSnOrModelOrSimpleSpecsOrBrandName: null,
      },
      total: 0,
      data: [],
      page: {
        pageNum: 1,
        pageSize: 10,
      },
      releaseUpCount: 0,
      authFlagList: [
        {
          label: '全部',
          value: null,
        },
        {
          label: '待审核',
          value: 'TOBEAUDITED',
        },
        {
          label: '审核通过',
          value: 'PASS',
        },
        {
          label: '审核驳回',
          value: 'REFUSE',
        },
      ],
    };
  },
  computed: {
    toolsAttrs () {
      return {
        refresh: true,
        zoom: true,
        fullScreen: this.isFullScreen,
        advancedSearch: true,
        custom: true,
      };
    },
    marketEnableList () {
      return [
        {
          label: '全部',
          value: null,
        },
        {
          label: '未发布',
          value: 'NOT',
        },
        {
          label: `已上架${this.releaseUpCount ? '(' + this.releaseUpCount + ')' : ''}`,
          value: 'UPPER',
        },
        {
          label: '已下架',
          value: 'DOWN',
        },
      ];
    },
  },
  methods: {
    getColor (v) {
      const green = ['PASS', 'UPPER'];
      const orange = ['TOBEAUDITED'];
      const red = ['REFUSE'];
      const grey = ['DOWN', 'NOT'];
      // const bule = ['TOBEAUDITED'];
      if (green.includes(v)) return 'green';
      if (orange.includes(v)) return 'orange';
      if (red.includes(v)) return 'red';
      if (grey.includes(v)) return 'grey';
      // if (bule.includes(v)) return 'bule';
      return '';
    },
    updateColumnList (columnList) {
      this.columnLists = [
        ...columnList,
        {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          fixed: 'right',
          width: 150,
          scopedSlots: { customRender: 'action' },
        },
      ];
    },
    handleValidate () {
      this.form.adaptedCategoryId = '';
    },
    handleSelectPlatFormCategory (v) {
      const categoryId = v.value.slice(-1)[0];
      this.form.adaptedCategoryId = categoryId;
    },
    handleSelectCategory (v) {
      const categoryId = v.value.slice(-1)[0];
      this.form.merchantGoodsCategoryId = categoryId;
    },
    handleSelectionChange (keys, rows) {
      this.selectedKeys = keys;
      this.selectedLists = rows || [];
    },
    handleCreate () {
      this.currentId = null;
      this.$refs.editDialogRef.ctrlType = null;
      this.$refs.editDialogRef.init();
      this.$refs.editDialogRef.dialogVisible = true;
    },
    handleBatchAction (action) {
      const ctrl = action === 'UPPER' ? '上架' : '下架';
      const goods = this.selectedLists.map(item => `${item.goodsName}_${item.sn}`).join('、');
      this.$confirm(`确认将商品【${goods}】${ctrl}吗？`, `${ctrl}`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async ()=>{
        const params = {
          storeId: this.storeInfo.id,
          goodsSkuIds: this.selectedKeys,
          marketEnable: action,
          underReason: '',
        };
        await updateMarketEnable(params);
        this.$message.success(`商品已${ctrl}`);
        this.handleSearch();
      });
    },
    handleGoodsDetail (id) {
      if (this.$withPermission('gongxutong:sale_goods:subscription:detail')) {
        this.currentId = id;
        this.$refs.goodsDetailDialogRef.dialogVisible = true;
      }
    },
    handleEmpty () {
      this.form = this.$options.data().form;
      this.timeArr = [];
      this.$refs.chooseGoodsCategoryRef.defaultValue = [];
      this.$refs.chooseGoodsPlatFormCategoryRef.handleClear();
    },
    handleReset () {
      this.outform = this.$options.data().outform;
      this.form = this.$options.data().form;
      this.page.pageNum = 1;
      this.page.pageSize = 10;

      this.handleSearch();
    },
    handleAdvancedQuery () {
      this.page.pageNum = 1;

      this.handleSearch();
    },
    handleSizeChange (_, size) {
      this.page.pageSize = size;

      this.handleSearch();
    },
    handleNumChange (num) {
      this.page.pageNum = num;

      this.handleSearch();
    },
    handleOutChange (key, o) {
      this.selectedKeys = [];
      this.selectedLists = [];

      this.outform[key] = o.value;

      this.page.pageNum = 1;

      this.handleSearch();
    },
    handleFullScreen (flag) {
      this.isFullScreen = flag;
    },
    async handleAction (record, action) {
      if (['modify', 'publish'].includes(action)) {
        this.currentId = record.id;
        this.$refs.editDialogRef.ctrlType = action;
        this.$refs.editDialogRef.initForm(record.id);
        this.$refs.editDialogRef.dialogVisible = true;
      }
      if (action === 'cancel') {
        this.$confirm(`取消发布后，商品将不在平台上做销售展示，是否取消发布【${record.goodsName}_${record.sn}】`, '取消发布', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async ()=>{
          await cancelRelease({ id: record.id });
          this.$message.success('商品已取消发布');
          this.handleSearch();
        });
      }
      if (action === 'marketEnable') {
        const ctrl = record.marketEnable === 'UPPER' ? '下架' : '上架';
        this.$confirm(`确认${ctrl}商品【${record.goodsName}_${record.sn}】？`, `${ctrl}商品`, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async ()=>{
          const params = {
            storeId: this.storeInfo.id,
            goodsSkuIds: [record.id],
            marketEnable: record.marketEnable === 'UPPER' ? 'DOWN' : 'UPPER',
            underReason: '',
          };
          await updateMarketEnable(params);
          this.$message.success(`商品已${ctrl}`);
          this.handleSearch();
        });
      }
    },
    async handleSearch () {
      const dealStatus = {
        marketEnable: null,
        releaseStatus: null,
      };
      if (this.outform.marketEnable === 'NOT') {
        dealStatus.releaseStatus = 'NOT';
      }
      if (this.outform.marketEnable !== 'NOT') {
        dealStatus.marketEnable = this.outform.marketEnable;
      }
      let params = {
        findCategoryFlag: true,
        storeId: this.storeInfo.id,
        saleType: 'PLATFORM_SALE', // 销售类型【PLATFORM_SALE：平台销售；SUBSCRIPTION_SALE：订阅销售】
        sourceType: 'XIAOZI_PLATFORM', // 商品来源【YIXIE_SHOP：1械网，XIAOZI_PLATFORM：小紫平台】
        ...this.outform,
        ...this.form,
        ...this.page,
        ...dealStatus,
        updateTimeStart: this.timeArr?.length ? new Date(this.timeArr[0]).getTime() : '',
        updateTimeEnd: this.timeArr?.length ? new Date(this.timeArr[1]).getTime() + 1000 * 60 * 60 * 24 : '',
        orderBy: [
          {
            orderByProperty: 'lastUpdateTime',
            orderByType: 'DESC',
          },
        ],
      };
      if (['UPPER', 'DOWN'].includes(params.marketEnable)) {
        params.releaseStatus = 'RELEASED';
      }
      const { body } = await getSkuPageList(params);
      this.data = body?.list || [];

      this.total = Number(body?.total || 0);

      if (this.drawerVisible) {
        this.drawerVisible = false;
      }
      // 查询统计数数量
      const count = await getSkuCount({
        authFlag: 'PASS',
        saleType: 'PLATFORM_SALE',
      });
      this.releaseUpCount = count?.body?.releaseUpCount || 0;
    },
    async handleOpenMarket () {
      let msg = {
        confirmButtonText: '我知道了',
        text: '',
        type: null,
      };
      const { body } = await tenantDetail({
        id: this.userInfo.tenantId,
        findActivateServiceFlag: true,
      });
      if (body.activateService && body.activateService.includes('小紫VIS')) {
        msg.text = '尊敬的用户：VIS用户暂时无法开通云仓。针对VIS用户，平台后续将推出【商城店铺】专属服务，届时敬请关注。如有疑问请联系021-52813076';
      } else if (this.userInfo.authenticationStatus === '1' && !this.companyInfo.authenticationAuditStatus) {
        if (this.userInfo.isPersonal) {
          msg.text = '请先至平台小程序完成小紫平台个人认证，认证审核通过后才能开通云仓。';
        } else {
          msg.type = 'auth';
          msg.confirmButtonText = '去认证';
          msg.text = '请先完成小紫平台企业认证，认证审核通过后才能开通云仓。';
        }
      } else if (this.userInfo.authenticationStatus === '1' && this.companyInfo.authenticationAuditStatus === '3') {
        if (this.userInfo.isPersonal) {
          msg.text = '小紫平台个人认证审核失败，请至平台小程序重新认证，认证审核通过后才能开通云仓。';
        } else {
          msg.type = 'auth';
          msg.confirmButtonText = '重新认证';
          msg.text = '小紫平台企业认证审核失败，请重新认证！认证审核通过后才能开通云仓。';
        }
      } else if (this.companyInfo.authenticationAuditStatus === '1' && this.userInfo.authenticationStatus === '2') {
        msg.text = `小紫平台${this.userInfo.isPersonal ? '个人' : '企业'}认证正在审核中，审核通过后才能开通云仓。`;
      }
      if (msg.text) {
        const h = this.$createElement;
        this.$msgbox({
          title: '',
          showCancelButton: true,
          showClose: true,
          cancelButtonText: '取消',
          confirmButtonText: msg.confirmButtonText,
          message: h('div', { style: 'padding: 0 20px;' }, [
            h('i', { class: 'el-icon-warning', style: 'color:#FAB007; font-size: 17px;margin-right: 10px' }),
            h('span', { style: 'font-size: 16px; font-weight: bold; color: #1F2733;' }, '开通云仓'),
            h('p', { style: 'padding: 5px 10px 5px 30px; font-weight: 400; font-size: 14px; color: #1F2733;' }, msg.text),
          ]),
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
              if (msg.type === 'auth') {
                this.$router.push('/systemSetting/corporate/certification');
              }
              done();
            } else {
              done();
            }
          },
        });
        return;
      }
      this.$refs.openMarketRef.dialogVisible = true;
    },
    async init () {
      const { body } = await companyDetail({ id: this.userInfo.tenantId });
      this.companyInfo = body || {};
      if (this.userInfo.authenticationStatus === '3') { // 已认证
        if (!this.userInfo.isPersonal) {
          const certCode = this.companyInfo.certCode || this.userInfo.certCode;
          if (certCode) {
            const { body } = await getMarketStoreByLicenseNum({ licenseNum: certCode }) || {};
            this.storeInfo = body || {};
            // console.log('企业云仓信息', this.storeInfo);
            if (this.storeInfo?.storeDisable === 'OPEN') {
              this.handleSearch();
            }
          } else {
            this.$message.warning('企业营业执照号不存在！');
          }
        }
        if (this.userInfo.isPersonal) {
          const { body } = await getMarketStoreByLinkPhone({ linkPhone: this.userInfo.phoneNumber }) || {};
          this.storeInfo = body || {};
          // console.log('个人云仓信息', this.storeInfo);
          if (this.storeInfo?.storeDisable === 'OPEN') {
            this.handleSearch();
          }
        }
      }
    },
  },
  async created () {
    this.userInfo = JSON.parse(this.$local.get('userInfo')) || {};
    await this.init();
    this.show = true;
  },
};
</script>
<style lang="scss" scoped>
.shop-list {
  height: 100%;
  @mixin tag_round() {
    padding: 4px 8px;
    border-radius: 4px;
  }

  .list-wrapper {
    height: 100%;
    display: flex;
    flex-direction: column;

    .content-wrapper {
      flex: 1;
      overflow: hidden;
      padding: 0 0 8px;

      .h-full {
        height: 100%;
        background-color: #fff;
        display: flex;
        flex-direction: column;

        .c_group {
          position: relative;

          .title {
            font-size: 14px;
            font-weight: 600;
            padding-right: 2em;
          }
        }

        .code {
          cursor: pointer;
          color: #237FFA;
        }

        .table-wrapper {
          padding: 16px 12px;
          flex: 1;
          overflow: auto;

          .ant-radio-button-wrapper {
            border-width: 0;
            background-color: #f2f4f7;

            &.active-radio {
              border-color: #e2f3fe;
              background-color: #e2f3fe;
              color: #237ffa;
            }
          }

          .ant-radio-button-wrapper:not(:first-child)::before {
            width: 0;
          }

          .c_tag {
            @include tag_round();
            margin-right: 0.2em;
          }

          .orange {
            background-color: #fefae0;
            color: #fab007;
          }
          .red{
            background: #FEE9E5;
            color: #FF5959;
          }

          .green {
            background: #E5FEEB;
            color: #14CA64;
          }

          .grey {
            background-color: #F2F4F7;
            color: #1F2733;
          }
          .bule {
            background: #e2f3fe;
            color: #237ffa;
          }
        }
      }
    }
  }

  .table-wrapper.fullscreen {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0px;
    z-index: 100;
    background: #ffffff;
  }

  /deep/.ant-table-body::-webkit-scrollbar {
    height: 12px;
    width: 12px;
  }

  /deep/ .ant-table-body::-webkit-scrollbar-thumb {
    border-radius: 8px;
    box-shadow: inset 0 0 5px #c9ced6;
    background: #c9ced6;
  }

  //鼠标移入样式
  /deep/ .ant-table-body::-webkit-scrollbar-thumb:hover {
    background: #c9ced6;
  }

  .advanced-search {
    .ant-form-item {
      margin-bottom: 8px;
    }
  }

  /deep/.ant-drawer-body {
    padding: 16px;
  }
  .empty {
    height: calc(100vh - 122px);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .empty-img {
      width: 140px;
      height: 140px;
    }
    .desc {
      padding-bottom: 20px;
      font-weight: 400;
      font-size: 16px;
      color: #1F2733;
      text-align: center;
    }
  }
}
</style>
